Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviewQueryString = exports.getPreviewPageStore = void 0;
exports.getPreviewPageStore = (adminCoreState) => {
    if (!adminCoreState || !('pagePreview' in adminCoreState.modules)) {
        return;
    }
    const pagePreview = adminCoreState.modules.pagePreview;
    if (!pagePreview.store) {
        return;
    }
    return pagePreview.store;
};
exports.getPreviewQueryString = (adminCoreState) => {
    const store = exports.getPreviewPageStore(adminCoreState);
    if (store && store.state.inPreviewMode) {
        return '?preview';
    }
    else {
        return '';
    }
};
//# sourceMappingURL=getters.js.map